import type { DeliverySeries, WindowStats } from "@aura/shared";
import { fmtInt, fmtNum, fmtPct } from "~/lib/format";

const MON = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

/**
 * Chart label for a period: "Sep 2026", "Q3 2026", "Oct 26, 2026". The live
 * period says "to date"; one that starts before every org's history does
 * gets an asterisk.
 */
export function periodLabel(p: DeliverySeries["periods"][number], grain: DeliverySeries["grain"]): string {
  const [y, m, d] = p.period.split("-").map(Number);
  const base =
    grain === "quarter"
      ? p.label
      : grain === "month"
        ? `${MON[(m ?? 1) - 1]} ${y}`
        : `${MON[(m ?? 1) - 1]} ${d}, ${y}`;
  return `${base}${p.live ? " (to date)" : ""}${p.partialHistory ? "*" : ""}`;
}

/** Shorter axis label: "Sep '26", "Q3 '26", "Oct 26". */
export function axisLabel(p: DeliverySeries["periods"][number], grain: DeliverySeries["grain"]): string {
  const [y, m, d] = p.period.split("-").map(Number);
  const yy = String(y ?? 0).slice(2);
  if (grain === "quarter") return `${p.short} '${yy}`;
  if (grain === "month") return `${MON[(m ?? 1) - 1]} '${yy}`;
  return `${MON[(m ?? 1) - 1]} ${d}`;
}

export function statsFor(s: DeliverySeries, period: string, key: string): WindowStats | undefined {
  return s.points.find((x) => x.period === period && x.key === key)?.stats;
}

export function mergedTable(series: DeliverySeries, groupKey = "total") {
  return {
    columns: ["Period", "Merged", "Checked", "Checked %", "Reviewed %", "Median h to 1st review", "Median h to merge"],
    rows: series.periods.map((p) => {
      const st = statsFor(series, p.period, groupKey);
      return [
        periodLabel(p, series.grain),
        fmtInt(st?.merged ?? 0),
        fmtInt(st?.checked ?? 0),
        fmtPct(st?.checkedPct),
        fmtPct(st?.reviewedPct),
        fmtNum(st?.medianHoursToFirstReview),
        fmtNum(st?.medianHoursToMerge),
      ];
    }),
  };
}
